import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles((theme) => ({
  papper: {
    minWidth: "580px",
    minHeight: "600px",
    [theme.breakpoints.down("xs")]: {
      minWidth: "100%",
    },
  },
  content: {
    display: "flex",
    flexGrow: 1,
    justifyContent: "center",
    alignItems: "center",
    minHeight: 0,
  },
  cityText: {
    marginRight: theme.spacing(2),
  },
  backButton: {
    marginRight: theme.spacing(2),
  },
}))

export default styles
